import {useParams} from "react-router-dom";
import {CutJob} from "./CutJob.tsx";


export function CutJobPage() {
    const {jobId} = useParams();
    return <CutJob jobId={jobId}/>

}